// Adding product to cart
export const ADD_CART_PROCESS = "ADD_CART_PROCESS";
export const ADD_CART_SUCCESS = "ADD_CART_SUCCESS";

// Remove product/ products from cart
export const REMOVE_CART_PROCESS = "REMOVE_CART_PROCESS";
export const REMOVE_CART_SUCCESS = "REMOVE_CART_SUCCESS";

// increase or decrease amount of product in cart
export const INCREASE_AMOUNT = "INCREASE_AMOUNT";
export const DECREASE_AMOUNT = "DECREASE_AMOUNT";

export const RESET_STATUS = "RESET_STATUS";
